import { CircularProgress } from "@suraasa/placebo-ui"
import { ToolType } from "api/resources/aiTools/types"
import Heading from "features/AItools/components/Heading"
import { getToolName } from "features/AItools/helper"

import ContentActions from "../../GenerationOutput/Export/ContentActions"
import SubjectiveAssessmentOutput from "../../GenerationOutput/SubjectiveAssessmentOutput"
import { SubjectiveAssessmentReturnType } from "../useSubjectiveAssessment"
import ProForm from "./ProForm"

type Props = {
  openLessonPlanSelector?: boolean
  subjectiveAssessmentContext: SubjectiveAssessmentReturnType
  toggleHistorySideBar: (state: boolean) => void
}

const SubjectiveAssessmentForm = ({
  openLessonPlanSelector = false,
  subjectiveAssessmentContext,
  toggleHistorySideBar,
}: Props) => {
  const {
    currentResponseId,
    setCurrentResponseId,
    promptDataId,
    pageLoading,
    onBack,
    ...context
  } = subjectiveAssessmentContext

  if (promptDataId && pageLoading) {
    return (
      <div className="grid place-items-center p-4">
        <CircularProgress />
      </div>
    )
  }

  if (currentResponseId) {
    return (
      <>
        <ContentActions
          onBack={onBack}
          currentResponseId={currentResponseId}
          toolType={ToolType.subjectiveAssessment}
          title={context.overviewData?.title}
          toggleHistorySideBar={toggleHistorySideBar}
          hideExportOutputButton={
            context.isError ||
            context.isLoading ||
            currentResponseId === undefined
          }
        />
        <SubjectiveAssessmentOutput
          {...context}
          currentResponseId={currentResponseId}
          setCurrentResponseId={setCurrentResponseId}
          onBack={onBack}
        />
      </>
    )
  }

  return (
    <>
      <Heading
        title={`${getToolName(ToolType.subjectiveAssessment)} Generator`}
        subtitle="Craft customised subjective evaluations, ensuring a comprehensive learning experience."
        toggleHistorySideBar={toggleHistorySideBar}
      />
      {/* <TogglePro
        isPro={enableProMode}
        onChange={state => setEnableProMode(state)}
        className="mb-2"
      /> */}
      <ProForm {...context} openLessonPlanSelector={openLessonPlanSelector} />
      {/* {enableProMode ? (
        <ProForm {...context} openLessonPlanSelector={openLessonPlanSelector} />
      ) : (
        <BasicForm
          {...context}
          openLessonPlanSelector={openLessonPlanSelector}
        />
      )} */}
    </>
  )
}

export default SubjectiveAssessmentForm
